<template>
  <div v-bind="$attrs" class="skelly" />
</template>

<style>
.skelly {
  display: inline-block;
  width: 100%;
  min-width: 32px;
  height: 32px;
  animation: 2s cubic-bezier(0.4, 0, 0.6, 1) 0s infinite normal none running pulse;
  border-radius: 4px;
  background-color: var(--skeleton-color, hsl(240deg 4.8% 95.9%));
  animation-timeline: auto;
  animation-range-start: normal;
  animation-range-end: normal;
}
</style>
